import React from "react";

import { IoMdSettings } from "react-icons/io";
import { FaCirclePlus } from "react-icons/fa6";
import { TiEdit } from "react-icons/ti";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { IoEyeOutline } from "react-icons/io5";
import { MdAddPhotoAlternate } from "react-icons/md";
import { RiVideoAddFill } from "react-icons/ri";

export const add_icon = <FaCirclePlus style={{ color: 'black', fontSize: '22px' }} />
export const edit_icon = <TiEdit style={{ color: '#FFFFFF', fontSize: '22px' }} />

export const delete_icon = <RiDeleteBin5Fill style={{ color: '#F7941D', fontSize: '22px' }} />
export const view_icon = <IoEyeOutline style={{ color: '#FFFFFF', fontSize: '22px' }} />


export const add_image = <MdAddPhotoAlternate style={{ color: 'black', fontSize: '22px' }} />
export const add_video = <RiVideoAddFill style={{ color: 'black', fontSize: '22px' }} />